module.exports = {
      id: "cross-in-circle-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#cross-in-circle-usage",
      toString: function () {
        return this.url;
      }
    }